import React from 'react';
import { Col } from 'antd';

import ImageComponent from '@sharedComponent/image-component';
import { gifs } from 'src/assets/gif';

const GifLoader = ({ src = gifs.Loader1 }) => {
	return (
		<Col style={{ display: 'flex', height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
			<ImageComponent src={src} />
		</Col>
	);
};

export default GifLoader;
